'use es6';

import memoize from 'transmute/memoize';
import { getStatus, getData } from './getters';
import { STARTED } from '../constants/senderKeyConstants';

/** @deprecated Sender map entries are always loaded; use `getSender`. */
export const isSenderLoading = memoize(sender => !getData(sender) && getStatus(sender) === STARTED);